import React from 'react';
import { LayoutDashboardIcon, ClipboardListIcon, DatabaseIcon, BarChart3Icon, ShieldCheckIcon, LogOutIcon, UserIcon } from 'lucide-react';
interface WebSidebarProps {
  children: React.ReactNode;
  activeTab: 'dashboard' | 'collections' | 'catalogs' | 'reports' | 'audit';
  onTabChange: (tab: 'dashboard' | 'collections' | 'catalogs' | 'reports' | 'audit') => void;
  onLogout: () => void;
}
export function WebSidebar({
  children,
  activeTab,
  onTabChange,
  onLogout
}: WebSidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    id: 'collections',
    label: 'Recolecciones',
    icon: ClipboardListIcon
  }, {
    id: 'catalogs',
    label: 'Catálogos',
    icon: DatabaseIcon
  }, {
    id: 'reports',
    label: 'Reportes',
    icon: BarChart3Icon
  }, {
    id: 'audit',
    label: 'Auditoría',
    icon: ShieldCheckIcon
  }] as const;
  return <div className="flex h-screen w-full bg-gray-100 overflow-hidden font-sans" data-id="element-303">
      {/* Sidebar */}
      <aside className="w-64 flex-shrink-0 flex flex-col text-white shadow-xl z-20" style={{
      backgroundColor: '#134073'
    }} data-id="element-304">
        {/* Logo Area */}
        <div className="h-20 flex items-center px-6 border-b border-white/10 bg-black/10" data-id="element-305">
          <div className="bg-white p-1.5 rounded-md h-10 w-10 flex items-center justify-center mr-3" data-id="element-306">
            <img src="https://cdn.magicpatterns.com/uploads/wszHE4itFVKfiMMSe74Psk/logohospigen.png" alt="Logo HSJD" className="h-full object-contain" data-id="element-307" />
          </div>
          <h1 className="font-bold text-lg leading-tight" data-id="element-308">
            Lavandería
            <br data-id="element-309" />
            HSJD
          </h1>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto" data-id="element-310">
          {navItems.map(item => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return <button key={item.id} onClick={() => onTabChange(item.id)} className={`w-full flex items-center px-3 py-3 rounded-lg transition-colors text-left ${isActive ? 'text-white shadow-md' : 'text-white/70 hover:bg-white/10 hover:text-white'}`} style={isActive ? {
            backgroundColor: '#3d99d2'
          } : {}} data-id="element-311">
                <Icon className={`w-5 h-5 mr-3 ${isActive ? 'text-white' : 'text-white/70'}`} data-id="element-312" />
                <span className="font-medium" data-id="element-313">{item.label}</span>
              </button>;
        })}
        </nav>

        {/* User Area */}
        <div className="p-4 border-t border-white/10 bg-black/10" data-id="element-314">
          <div className="flex items-center mb-4 px-2" data-id="element-315">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center mr-3" data-id="element-316">
              <UserIcon className="w-5 h-5 text-white" data-id="element-317" />
            </div>
            <div data-id="element-318">
              <p className="text-sm font-bold text-white" data-id="element-319">Admin Usuario</p>
              <p className="text-xs text-white/60" data-id="element-320">Supervisor</p>
            </div>
          </div>
          <button onClick={onLogout} className="w-full flex items-center justify-center px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-white text-sm font-medium transition-colors" data-id="element-321">
            <LogOutIcon className="w-4 h-4 mr-2" data-id="element-322" />
            Cerrar Sesión
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden" data-id="element-323">
        {/* Top Header */}
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-8 shrink-0 shadow-sm z-10" data-id="element-324">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-325">
            {navItems.find(i => i.id === activeTab)?.label}
          </h2>
          <div className="flex items-center text-sm text-gray-500 font-medium" data-id="element-326">
            {new Date().toLocaleDateString('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </div>
        </header>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto p-8" data-id="element-327">{children}</div>
      </main>
    </div>;
}